import lodash from 'lodash';
import { getState, getFormValue } from '@/store';
import {
  getQueryParam,
  getHashParam,
  addDay,
  addMonth,
  addYear,
  mergeObjectInArray,
  getBirthday,
  getSex,
} from '@/utils/tool';
import { rulesProduct } from '@/utils/planRelationMethods/rulesProduct.js';
import { PREMIUM, PLAN_ID, OPEN_RENEWAL } from '@/constants';
import handlePlan from '@/actions/handlePlan';

const hour = 1000 * 60 * 60;
const day = hour * 24;
const now = Date.now();
const today = new Date().setHours(0) - (now % hour);
const start = today + day * 1;
const end = addYear(start, 1) - 1;

// 通过页面id获取页面数据
export const getPage = (pageId) => {
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;

  return pageList.find((item = {}) => {
    const a = String(item.pageId);
    const b = String(pageId);
    return a === b;
  });
};
// 通过弹窗模块id获取弹窗配置的数据
export const getModal = (modalId) => {
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;

  for (let v = 0; v < pageList.length; v += 1) {
    const page = pageList[v] || {};
    const { moduleList = [] } = page;

    for (let i = 0; i < moduleList.length; i += 1) {
      const curr = moduleList[i] || {};
      const { id, templateModuleId, children = [] } = curr;

      if (id === modalId || templateModuleId === modalId) {
        for (let a = 0; a < children.length; a += 1) {
          const child = children[a] || {};
          const { component } = child;

          if (component === 'modal') {
            return child;
          }
        }
      }
    }
  }
};

// 获取当前页码
export const getPageNum = () => {
  return getHashParam('page') ? +getHashParam('page') : 1;
};

const findModule = (fn) => (curr = {}) => {
  const { children = [] } = curr;
  const useful = fn && fn(curr);

  if (useful) {
    return curr;
  }

  if (!children) {
    return;
  }

  return children.reduce((res, child = {}) => {
    return res || findModule(fn)(child);
  }, undefined);
};

const hasProductList = (curr = {}) => {
  const planId = getState(PLAN_ID);

  const { attrs = {} } = curr;

  if (!attrs) {
    return false;
  }

  const { dataSource = {} } = attrs;
  const { planConfigAdditionProductList, planConfigMainProductList, serviceList, id } = dataSource;

  const useful = planConfigAdditionProductList !== undefined
    || planConfigMainProductList !== undefined
    || serviceList !== undefined;

  if (!useful) {
    return false;
  }

  if (id && id === planId) {
    return true;
  }
  return false;
};

const hasFormKey = (formKey) => (curr = {}) => {
  const { attrs = {}, formKey: currFormKey = '' } = curr;

  if (!currFormKey) {
    return false;
  }

  if (!attrs) {
    return false;
  }

  return currFormKey.includes(formKey);
};

const productListToPackageList = (productList = []) => {
  return productList.reduce((res = [], product = {}) => {
    const {
      productCode,
      productName,
      planConfigPackageDTO = {},
      planConfigLiabilityList = [],
      fixedSumInsuredValue,
    } = product;
    if (product.insurancePeriodEnumValueList?.length === 1) {
      product.insurancePeriod = product.insurancePeriodEnumValueList[0].value;
      product.insurancePeriodUnitType = product.insurancePeriodEnumValueList[0].unitType;
    }
    if (product.paymentPeriodEnumValueList?.length === 1) {
      product.paymentPeriod = product.paymentPeriodEnumValueList[0].value;
      product.paymentPeriodUnitType = product.paymentPeriodEnumValueList[0].unitType;
    }

    const { packageCode, packageName } = planConfigPackageDTO;

    // 责任
    const liabilityList = planConfigLiabilityList.map((liability = {}) => {
      // UNCOMPLETED
      const {
        fixedSumInsuredValue: _fixedSumInsuredValue = {},
        liabilityName,
        liabilityCode,
      } = liability;
      const { value } = _fixedSumInsuredValue;

      return {
        sumInsured: value,
        liabilityName,
        liabilityCode,
      };
    });

    const currPackage = res.find((item = {}) => {
      const { packageCode: itemPackageCode, packageName: itemPackageName } = item;

      return packageCode === itemPackageCode && packageName === itemPackageName;
    });
    const { value } = fixedSumInsuredValue || {};

    const _productList = [
      {
        ...product,
        productCode,
        productName,
        liabilityList,
        sumInsured: value,
      },
    ];

    const curr = {
      packageCode,
      packageName,
      _productList,
    };

    if (currPackage) {
      const { productList: currProductList = [] } = currPackage;

      const currProduct = currProductList.find((item = {}) => {
        const { productCode: itemProductCode, productName: itemProductName } = item;

        return productCode === itemProductCode && productName === itemProductName;
      });

      if (currProduct) {
        currProduct.liabilityList = (currProduct.liabilityList || []).concat(liabilityList);
      } else {
        currPackage.productList = (currPackage.productList || []).concat(_productList);
      }
    } else {
      res.push(curr);
    }
    return res;
  }, []);
};
// 根据条件在 在当前页面配置中 查询模块数据 fn(组件|模块数据) 返回条件的组件或者模块的配置信息
export const findModuleFromPage = (fn) => {
  const pageOrder = getPageNum();
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;

  const page = pageList.find((item = {}) => item.pageOrder === pageOrder) || {};
  const { moduleList = [] } = page;

  return findModule(fn)({ children: moduleList });
};

// 判断当前页面是否含有某个模块
export const findModuleFromCurrPage = (moduleName) => {
  const pageOrder = getPageNum();
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;

  const page = pageList.find((item = {}) => item.pageOrder === pageOrder) || {};
  const { moduleList = [] } = page;

  return moduleList.some((item) => {
    if (typeof moduleName === 'string') {
      return item.component === moduleName;
    }
    if (Array.isArray(moduleName)) {
      return moduleName.indexOf(item.component) !== -1;
    }
    return false;
  });
};

// 根据条件在 所有页面配置中 查询模块数据 fn(组件|模块数据) 返回条件的组件或者模块的配置信息
export const findModuleFromState = (fn) => {
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;

  return pageList.reduce((res, page = {}) => {
    const { moduleList = [] } = page;

    return res || findModule(fn)({ children: moduleList });
  }, undefined);
};

// 获取当前计划产品组合数据
export const getPackageList = () => {
  const curr = findModuleFromState(hasProductList) || {};
  const { attrs: { dataSource = {} } = {} } = curr;
  const { planConfigMainProductList = [], planConfigAdditionProductList = [] } = dataSource;
  planConfigMainProductList.forEach((item) => {
    item.ProductType = 'main';
  });
  planConfigAdditionProductList.forEach((item) => {
    item.ProductType = 'addition';
  });
  const productList = [...planConfigMainProductList, ...planConfigAdditionProductList];

  return productListToPackageList(productList) || [];
};

// 获取缴费频率字段
// (value = "缴费频率 single：趸交 year：年缴 ：halfYear：半年缴 season：季缴 month：月缴 day：日缴")
const getDefaultPaymentFrequency = (packageList) => {
  const [{ paymentFrequencyList } = {}] = packageList?.[0]?.productList || [];

  //  默认值, 从选中的计划中获取
  const defaultValue = Array.isArray(paymentFrequencyList) ? paymentFrequencyList.join('') : '';

  const paymentFrequency = getState('formValues.common.paymentFrequency');
  return paymentFrequency || defaultValue || 'year';
};

// 获取保障起期
const getDefaultInsuranceStartDate = () => {
  const insuranceStartDate = new Date(`${getState('formValues.common.insuranceStartDate')} 00:00:00`.replace(/\-/g, '/') || '');
  if (Number.isNaN(insuranceStartDate.getTime())) {
    return start;
  }
  return insuranceStartDate.getTime();
};

// 获取保障止期
const getDefaultInsuranceEndDate = () => {
  const insuranceEndDate = new Date(`${getState('formValues.common.insuranceEndDate')} 00:00:00`.replace(/\-/g, '/') || '');
  if (Number.isNaN(insuranceEndDate.getTime())) {
    return end;
  }
  return insuranceEndDate.getTime();
};
// 保障期间
const getDefaultInsurancePeriod = () => {
  const fn = hasFormKey('insurancePeriod');
  const curr = findModuleFromState(fn) || {};

  const { attrs = {} } = curr;
  const { display: { defaultValue = '[]' } = {} } = attrs;
  // ;
  try {
    const value = JSON.parse(defaultValue);

    if (Array.isArray(value)) {
      return value.join('-');
    }
    return value;
  } catch (e) {
    console.error(e);
  }
};

// UNCOMPLETED
const getBasePerson = () => {
  return {
    certType: 'I',
    // allowInsure: true, // 多被保人通过这个字段判断问卷填写状态  不给默认
  };
};

export const getNewDate = (_start, period) => {
  if (_start && period) {
    const [diff, type] = period.split('-');
    if (type === 'D') {
      return addDay(_start, diff) - 1;
    }
    if (type === 'M') {
      return addMonth(_start, diff) - 1;
    }
    if (type === 'Y') {
      return addYear(_start, diff) - 1;
    }
  }
};
// 收集数据作为接口请求数据 试算接口 和下一步接口 利益演示接口都会调用
export const getFetchBaseData = () => {
  const isContainTrail = findModuleFromCurrPage('policyHolderModule')
    || findModuleFromCurrPage('insurancePlanTrialCalculation');
  // 判断当前页面是否是智能健告前，不能把智能结果提交
  const isContainCalc = findModuleFromCurrPage('insurancePlanTrialCalculation');
  // 健告人员列表时也要校验投保规则
  // 投保主体
  const holderType = getState('configJson.fields.holderType') || 'person';
  // 订单数据
  const orderDetail = getState('orderDetail') || {};
  // 页面表单数据
  const values = getState('formValues') || {};
  const beneficiary = getFormValue('beneficiary') || []; // 受益人
  const urlParams = getState('urlParams') || {};
  const extraInfo = getState('extraInfo') || {};
  const premiumInfo = getState('premium');
  const planId = getState(PLAN_ID);
  const { encryptOrderNo, orderNo } = getState('FETCH_STORE') || {};
  const openRenewal = getState(OPEN_RENEWAL);

  // 计划列表
  const planList = getState('goodsDetail.planList');

  const insuranceCategory = getState('goodsDetail.insuranceCategory');
  // 保障周期
  const insurancePeriod = getDefaultInsurancePeriod();
  // 保障起期
  const insuranceStartDate = getDefaultInsuranceStartDate();
  // 保障止期
  const insuranceEndDate = getDefaultInsuranceEndDate();
  // 缴费频率
  const paymentFrequency = getDefaultPaymentFrequency();

  const basePerson = getBasePerson() || {};
  const {
    channelCode,
    channelNo,
    goodsId,
    templateRelationId,
    promotionId = templateRelationId,
    thirdOrderNoType,
    thirdOrderNo,
    agentNo,
    orderOrigin,
    urlExtraInfo = '{}', // 2021年11月22日 王勇: 要加在地址栏上并在下一步接口传入 extraInfo 中, 格式为{"123": "asd"}
  } = getQueryParam() || {};
  const _urlExtraInfo = JSON.parse(urlExtraInfo);
  // eslint-disable-next-line prefer-const
  let { thirdChannelCode, insuredList: _insuredList = [], holder: ODHolder = {}, agent: ODAgent = {} } = orderDetail;
  if (!_insuredList) {
    _insuredList = [];
  }
  if (!ODAgent) {
    ODAgent = {};
  }
  const {
    insured: formInsured = [],
    holder: policyHolder = {},
    trailElement,
    common,
  } = values;
  // const holderObj = calcObj?.holder || [];
  const trailHolder = trailElement?.[0]?.[0];
  const trailInsure = trailElement?.[1] || [];
  // 通用试算要素
  let trailCommon = trailElement?.[2]?.[0] || {};
  // 如果试算页面有投保人信息  也可以在这里处理优先级
  let holder = policyHolder; // 这里默认取holder的信息，
  // 进入页面时回显detail数据回显保证这两处被保人数据一致, 但是因为页面中会有修改, 所以要根据页面处理使用时的优先级
  let newInsure = formInsured;

  // 试算页 trailElement 的数据优先
  // 判断页面中是否有被保人信息试算模块
  // 试算页面和信息填写页面的 投保人和被保人 字段不同，提交数据的时候要判断是那个页面中
  if (findModuleFromCurrPage('insuredElementModule')) {
    newInsure = mergeObjectInArray(formInsured, trailInsure) || [];
  } else {
    newInsure = mergeObjectInArray(trailInsure, formInsured) || [];
  }

  const getSelectedPlanData = () => {
    //  先从store中获取当前保险计划，如果没有再从 保险计划试算信息收集 组件中获取
    let plan = getState('insurancePlan');
    const formValues = getState('formValues') || {};
    if (!plan) {
      const collectModule =
        findModuleFromState((module) => {
          return module.component === 'insurancePlanTrialCollect';
        }) || {};
      plan = collectModule.attrs?.plan;
    }
    return {
      plan,
      formValues,
    };
  };

  let packageList = handlePlan(getSelectedPlanData())?.planConfigPackageList;
  packageList = packageList || (_insuredList && _insuredList[0]?.packageList) || getPackageList();

  // 给每个产品塞入利益演示表
  const productBenefit = getState('productBenefit') || {};
  Object.keys(productBenefit).forEach((key) => {
    packageList?.forEach((pack) => {
      pack.productList?.forEach((product) => {
        if (String(product.id) === key) {
          product.benefitShowId = productBenefit[key];
        }
      });
    });
  });

  // 获取问卷信息
  const noticeQuestion = getState('healthNoticeInformation') || {};
  const { holderNotice, insuredNotice = [] } = noticeQuestion;
  // 投保人的问卷填写状态
  const holderAllowInsure = isContainTrail ? null : ODHolder?.allowInsure;
  debugger
  // 投保人信息
  holder = {
    allowInsure: holderAllowInsure,
    customerType: holderType,
    noticeQuestion: holderNotice,
    person: {
      ...basePerson,
      // ...holderObj,
      ...trailHolder,
      ...ODHolder?.person,
      ...holder,
      allowInsure: holderAllowInsure,
    },
    company: {
      ...basePerson,
      // ...holderObj,
      ...trailHolder,
      ...ODHolder?.person,
      ...holder,
      allowInsure: holderAllowInsure,
    },
  };

  // 在第一页调用下一步接口的时候不传被保人列表
  // currentPage !== '1' ? 被保人信息 : undefined;
  // 2020年12月2日 不能不传, 健康险是在第一个页面进行试算的
  // 告知列表数据
  const { checkedList } = getState('noticeList') || {};

  const filteredInsured = _insuredList && _insuredList.length
      ? _insuredList.filter((item) => item.selected !== false).length
      : newInsure.filter((item) => item.selected !== false).length || 0;

  let insuredLength = checkedList && checkedList.length ? checkedList.length : filteredInsured;

  if (findModuleFromCurrPage('insuredModule') || findModuleFromCurrPage('insuredElementModule')) {
    insuredLength = newInsure.filter((item) => item.selected !== false).length || 0;
  }

  let insuredList = [..._insuredList];

  if (newInsure.length > 0) {
    insuredList = newInsure.map((item = {}, index) => {
      // 被保人有计划选择
      const insuredPlanPackageList = item.planId
        ? handlePlan({
            plan: planList.find((planItem) => String(planItem.id) === String(item.planId)),
            formValues: item,
          })?.planConfigPackageList
        : packageList || [];

      const pack = isContainCalc
        ? insuredPlanPackageList
        : lodash.cloneDeep(rulesProduct(insuredPlanPackageList, item, insuredLength));
      //  有保险计划模块时暂时前端不做投保规则校验
      const { holderRelation } = item;
      // 找不到就是undefined  不能给默认值
      const currentInsured = _insuredList?.find((ins) => ins.person?.certNo === item.certNo) || {};
      let allowInsure = isContainTrail ? null : currentInsured.allowInsure;

      let newItem = { ...basePerson, ...item, allowInsure };

      // 这里取到的投保人为空会覆盖被保人信息 导致试算页面利益演示接口报: 被保人生日性别不能为空
      if (holderRelation && holderRelation.toLocaleLowerCase() === 'self') {
        // 计划书转投保场景:如果是试算页面以被保人的信息为试算依据
        if (findModuleFromCurrPage('insuredElementModule')) {
          newItem = { ...holder.person, ...newItem };
        } else {
          newItem = { ...newItem, ...holder.person };
        }
        holder.person = newItem;
      }
      if (!newItem.birthday && newItem.certNo) {
        newItem.birthday = getBirthday(newItem.certNo);
        newItem.gender = getSex(newItem.certNo);
      }

      // 受益人类型 如果取不到值 就默认法定受益人
      const beneficiaryType = beneficiary[index]?.[0]?.beneficiaryType || 'legalBeneficiary';
      // 组装受益人信息
      let beneficiaryList = [];
      if (beneficiaryType !== 'legalBeneficiary') {
        beneficiaryList = beneficiary?.[index]?.map((bene) => {
          const {
            beneficiaryNature,
            benefitDistributeMode,
            benefitOrder,
            benefitRatio,
            company,
            customerType = holderType,
            insuredRelation,
            insurantRelation,
          } = bene; // 解构受益人DTO 需要的数据
          bene.insuredRelation = bene.insurantRelation; // key错的  改回来
          return {
            beneficiaryNature,
            benefitDistributeMode,
            benefitOrder,
            benefitRatio,
            company,
            customerType,
            insuredRelation,
            insurantRelation,
            person: bene,
          };
        });
      }

      let { selected } = currentInsured;
      // 如果有 说明是健告列表页, selected状态使用store存储的  否则使用insured自带的
      if (checkedList) {
        selected = checkedList.indexOf(newItem.certNo) !== -1;
      }

      const isFlagPage = findModuleFromCurrPage([
        'healthInfoModule',
        'healthNotificationListModule',
        'insuredConfirmModule',
        'policyHolderInfoModule',
      ]);
      if (!isFlagPage) {
        allowInsure = null;
        selected = true;
      }
      return {
        ...currentInsured,
        planId: item.planId,
        selected,
        allowInsure, // 告知填写状态
        noticeQuestion: insuredNotice?.[index] ? insuredNotice?.[index] : {},
        insuredType: holderType,
        person: newItem,
        premium: newItem.premium,
        company: newItem,
        holderRelation,
        packageList: pack,
        beneficiaryType,
        beneficiaryList,
      };
    });
  }
  // 处理试算没有传计划信息
  if (insuredList.length === 0) {
    insuredList.push({
      // allowInsure: true, // 告知填写状态
      // noticeQuestion: insuredNotice?.[index] ? insuredNotice?.[index] : {},
      insuredType: holderType, // 如果投保主体是公司则 后端去company 字段 个人去 company
      person: {},
      company: {},
      // holderRelation,
      packageList,
      // beneficiaryType,
      // beneficiaryList,
    });
  }

  if (findModuleFromCurrPage('healthOrderConfirmModule')) {
    const premium = getState(PREMIUM);
    if (premium) {
      common.totalPremium = premium.type === 'month' ? premium.value[0] : premium.value;
    }
  }

  // 从通用信息中排除缴费频率字段
  const { paymentFrequency: payF, ...otherCommon } = common || {};
  // 保费数据
  const premium = premiumInfo?.initialPremium;
  const initialPremium = premiumInfo?.initialPremium;

  const agent = getState('agent') || {};

  // 横琴投被保人、代理人告知数据挂载
  if (getState('questionList')) {
    holder.noticeQuestion = {
      noticeType: 'insureNotice',
      noticeDetailList: (getState('questionList.holderList') || []).map((item) => ({
        noticeCode: item.code,
        noticeContent: item.content || '',
        noticeAnswer: item.reply,
      })),
    };

    insuredList.forEach((insured) => {
      insured.noticeQuestion = {
        noticeType: 'insureNotice',
        noticeDetailList: (getState('questionList.insuranceList') || []).map((item) => ({
          noticeCode: item.code,
          noticeContent: item.content || '',
          noticeAnswer: item.reply,
        })),
      };
    });

    // agent.noticeQuestion = {
    //   noticeType: 'insureNotice',
    //   noticeDetailList: (getState('questionList.agentList') || []).map((item) => ({
    //     noticeCode: item.code,
    //     noticeContent: item.content || '',
    //     noticeAnswer: item.reply,
    //   })),
    // };
  }

  // 通过当前页面存在的模块判断 后面优化
  if (findModuleFromCurrPage('trailCommonModule')) {
    trailCommon = Object.assign(otherCommon, trailCommon) || {};
  } else {
    trailCommon = Object.assign(trailCommon, otherCommon) || {};
  }

  return {
    premium,
    insuranceCategory,
    initialPremium,
    channelCode,
    channelNo,
    goodsId,
    thirdOrderNoType,
    thirdOrderNo, // 第三方订单号
    thirdChannelCode,
    encryptOrderNo,
    orderOrigin,
    orderNo,
    agentCode: agentNo,
    planId,
    holder,
    insuredList,
    packageList,
    paymentFrequency,
    insuranceStartDate,
    insuranceEndDate,
    promotionId,
    extraInfo: {
      ...extraInfo,
      ...urlParams,
      ..._urlExtraInfo,
      ...trailCommon,
      openRenewal,
      insurancePeriod,
    },
    currentUrl: window.location.href,
    allowInsure: orderDetail.allowInsure !== undefined ? orderDetail.allowInsure : true, // 处理智能问卷不通过时，点击提交不能正常跳转
    noticeType: 'healthNotice',
    noticeObjectType: 'insured',
    dataSource: 'h5',
    pageExtraInfo: {
      common,
    },
    agent: {
      ...ODAgent,
      ...agent,
    }, // 追加一个agent字段，把横琴中新增的营销员告知的数据带过去
  };
};

// 通过模块名查找页面
export const findPageByModule = (moduleName) => {
  const config = getState('configJson');
  return config.pageList?.find((page) => {
    return (
      page.moduleList?.find((module) => {
        return module.component === moduleName;
      }) !== undefined
    );
  });
};

// 获取前一级formKey
// a.c.d === > a.c
// a[0][4] ===> a[0]
export const getPreLeveFormKey = (formKey) => {
  const keys = formKey.split(/\.|\[/g);
  const nextkeys = keys.map((i) => {
    if (/\]/g.test(i)) {
      return `[${i}`;
    }
    return i;
  });
  nextkeys.pop();
  const preKey = nextkeys.join('.').replace('.[', '[');
  return preKey;
};

// 获取当前模块的指定的formkey
export function getStatePath(currentFormKey, name) {
  const preKey = getPreLeveFormKey(currentFormKey);
  return `${preKey}.${name}`;
}

// 通过页面id获取页面配置数据
export const getPageConfigByPageId = (pageId) => {
  const configJson = getState('configJson') || {};
  const { pageList = [] } = configJson;
  return pageList.find((item = {}) => {
    const a = String(item.pageId);
    const b = String(pageId);
    return a === b;
  });
};

// 项目上定制的获取参数的方法 待处理
export function getFetchBaseDataNotRelyOnFormValues() {

}

// 日志打印方法
export function log(...rest) {
  const { debug } = getQueryParam();
  // eslint-disable-next-line no-console
  return debug ? console.log.apply(null, rest) : '';
}

export const getReqNextStepDataBase = getFetchBaseData;